import axios from "axios";

import env from "variables/config";
import { errorHandler } from "./utils";

axios.defaults.baseURL = env.apiUrl;

const config = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
        },
    };
};

export const getEmailTemplates = async () => {
    const res = await axios.get("/email-templates", config()).catch(errorHandler);
    return res.data;
};

export const createEmailTemplate = async (data: any) => {
    const res = await axios
        .post("/email-templates", data, config())
        .catch(errorHandler);
    return res.data;
};

export const updateEmailTemplate = async (id: string, data: any) => {
    const res = await axios
        .put(`/email-templates/${id}`, data, config())
        .catch(errorHandler);
    return res.data;
};

export const deleteEmailTemplate = async (id: string) => {
    const res = await axios
        .delete(`/email-templates/${id}`, config())
        .catch(errorHandler);
    return res.data;
};
